import { FC, useEffect } from 'react';
import NoGames from 'src/assets/images/plugs/noSearchGames.webp';
import { useSearchParams } from 'react-router';
import { useModalContext } from 'src/hooks/useModalContext';
import { useApiContext, useGetUserCountry, useWindowSize } from 'react-easyrocket';
import { GamesControlPanel } from 'src/components/Games/GamesControlPanel';
import { GamesBlock } from 'src/pages/Main/components/GamesBlock';
import { MainPageBannersMobile } from 'src/pages/Main/components/MainPageBannersMobile';
import { Wrapper } from 'src/components/Wrapper';
import { PageHeadSEO } from 'src/components/PageHeadSEO';
import { RecentWinners } from './components/RecentWinners';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { getAffiliateData } from 'src/hooks/useGetCountryConfig/utils/getAffiliateData';
import { EventIcon } from 'src/components/svg/CategorySwitcher';
import { useEvent } from 'src/context/usePromoEvent';
import { EVENT_NAME } from 'src/config/helpers';

const MainPage: FC = () => {
  const { eventActive } = useEvent();
  const isEventActive = eventActive.eventDays;
  const { isMobileLayout } = useWindowSize();
  const { openModal } = useModalContext();
  const [params] = useSearchParams();
  const { isAuthenticated } = useApiContext();
  const { startRegistration } = useAuthFlow();
  const { isGBR } = useGetUserCountry();
  const hasAffiliateLink = getAffiliateData();
  const isHideRecentWinners = isGBR && !hasAffiliateLink && !isAuthenticated;

  useEffect(() => {
    const referral = params.get('referral');
    if (referral && !isAuthenticated) {
      startRegistration();
    }
  }, [params, isAuthenticated, openModal]);

  return (
    <>
      <PageHeadSEO />
      {isMobileLayout && <MainPageBannersMobile />}
      <Wrapper>
        {!isMobileLayout && <MainPageBannersMobile />}
        {!isHideRecentWinners && <RecentWinners />}
        <GamesControlPanel target="globalSearch" image={NoGames} />
        {isEventActive && <GamesBlock categoryId={EVENT_NAME} icon={<EventIcon />} />}
        <GamesBlock categoryId="top" totalGames={8435} />
        <GamesBlock categoryId="live" totalGames={8435} />
        <GamesBlock categoryId="new" totalGames={8435} />
      </Wrapper>
    </>
  );
};

export default MainPage;
